<template>
  <section id="hero" class="hero">
    <Slides :image="slides[currentSlide]"></Slides>
  </section>
</template>
<script>
import Slides from '@/components/Slides'
export default {
  components: {
    Slides,
  },
  name: 'hero',
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          title: 'Soluciones Logisticas',
          subtitle: 'a la medida de sus necesidades',
          desc:
            'Son muchas las opciones que tenemos para ofrecer a las empresas de hoy en día, con un amplio abánico de beneficios de integración logística.',
          class: 'slide1',
        },
        {
          title: 'Agilidad',
          subtitle: 'para el desarrollo del resto de procesos logísticos.',
          class: 'slide2',
          right: true,
        },
        {
          title: 'Mejora',
          subtitle: 'en el control y la distribución de las mercancías.',
          class: 'slide3',
        },
        {
          title: 'Disminución',
          subtitle: 'de tiempos de procesos',
          class: 'slide4',
          right: true,
          special: true,
        },
        {
          title: 'Mayor Nivel',
          subtitle: 'de satisfacción al cliente',
          class: 'slide5',
        },
      ],
    }
  },
  methods: {
    move() {
      let activeSlide = this.currentSlide
      activeSlide++
      if (activeSlide >= this.slides.length) {
        activeSlide = 0
      }
      this.currentSlide = activeSlide
    },
  },

  created() {
    let vm = this
    setInterval(() => {
      vm.move()
    }, 5000)
  },
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  height: 100vh;
  max-height: 500px;
  background-color: #333;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

@media (min-width: 768px) {
  .hero {
    max-height: 600px;
  }
}
@media (min-width: 992px) {
  .hero {
    max-height: 700px;
  }
}
</style>
